export { default as LogoIcon } from "assets/bulgari_logo.png";
export { ReactComponent as FlipIcon } from "assets/flip.svg";
export { ReactComponent as ShareIcon } from "assets/share.svg";
export { ReactComponent as ZoomIcon } from "assets/zoom.svg";

// old
export { ReactComponent as JewelryIcon } from "assets/jewelry.svg";
export { ReactComponent as RingIcon } from "assets/ring.svg";

// new
export { ReactComponent as AccessoriesActiveIcon } from "assets/accessories-active.svg";
export { ReactComponent as AccessoriesIcon } from "assets/accessories.svg";
export { ReactComponent as BraceletsActiveIcon } from "assets/bracelets-active.svg";
export { ReactComponent as BraceletsIcon } from "assets/bracelets.svg";
export { ReactComponent as EarringActiveIcon } from "assets/earring-active.svg";
export { ReactComponent as EarringIcon } from "assets/earring.svg";
export { ReactComponent as NecklacesActiveIcon } from "assets/necklace-active.svg";
export { ReactComponent as NecklacesIcon } from "assets/necklaces.svg";
export { ReactComponent as RingActiveIcon } from "assets/ring-active.svg";
export { ReactComponent as WatchesActiveIcon } from "assets/watches-active.svg";
export { ReactComponent as WatchesIcon } from "assets/watches.svg";

export { ReactComponent as ArrowIcon } from "assets/arrow.svg";
export { ReactComponent as CalendarIcon } from "assets/calendar.svg";
export { ReactComponent as CartBagActiveIcon } from "assets/cart-bag-active.svg";
export { ReactComponent as CartBagIcon } from "assets/cart-bag.svg";
export { ReactComponent as DropAHintIcon } from "assets/drop-a-hint.svg";
export { ReactComponent as MenuCloseIcon } from "assets/menu-close.svg";
export { ReactComponent as MenuHamburgerIcon } from "assets/menu-hamburger.svg";
export { ReactComponent as NewIcon } from "assets/new.svg";
export { ReactComponent as SizeArrowDownIcon } from "assets/sizeArrowDown.svg";
export { ReactComponent as WishListIcon } from "assets/wishlist.svg";

export const BookAppointmentUrl =
  "https://api.cresclab.com/system/a/?a=BsjbNeylOKz2f8cs5lBvty742ncVVf/l6%2BISzP1UIaa3FwiTA8iYx7ICtqr9m/a8MyKsKKnSpLJU53X5VyNStCRkTdZZ2AzRDFJiSFHg7laFhBDRIOKYrOHA1q2udgVy";
export const PrivacyUrl =
  "https://www.bulgari.com/en-th/privacy-policy/privacy-policy--page__terms.html";

export const bvRulerUrl =
  "https://media2.bulgari.com/image/upload/v1599655647/pdf/ring-bracelet-sizer/bulgari_ring_tape_measure_en_edb7fw.pdf?_gl=1*nn7nk1*_gcl_au*MTI0ODczNDc4Ny4xNzU4Njk5NjA4*FPAU*MjA3NzI2Njk4Mi4xNzU4Njk4NjE4*_ga*MTgwMjA3MzA3Ny4xNzU4Njk4NjE4*_ga_8BD8QTE75Q*czE3NTg3MDM5NzYkbzMkZzEkdDE3NTg3MDQyMDUkajU0JGwwJGgxNDIzNzcwMzI1*_fplc*d214MDAyY29hWjY3UzhhZEdWQmVKVHlwUG1aU250ZlB0RVJ6ZnJHRlVIUk51aHFSU3NRNkFrck9WOHpreklnWlNSTXJmZGc3TjFsYTAxd0JsVTE3V3pNY0NCbzEwZVYwWkdzVXAxOU1nT1lEQVVNNXZSeSUyRkRZdVFOYmRtTGclM0QlM0Q.*_ga_70E47998JL*czE3NTg3MDM5NzYkbzMkZzEkdDE3NTg3MDQyMDUkajU0JGwwJGgw";

export const ShopByCollectionImageUri =
  "https://d2zayvicus4xl7.cloudfront.net/bulgari-th-eshop/shop-by-collection.png";

export const ShopByCategoryImageUri =
  "https://d2zayvicus4xl7.cloudfront.net/bulgari-th-eshop/shop-by-category.png";

export { ReactComponent as AccountIcon } from "assets/account.svg";
export { ReactComponent as B01RingIcon } from "assets/B01-ring.svg";
export { ReactComponent as BackIcon } from "assets/back.svg";
export { ReactComponent as BagIcon } from "assets/bag.svg";
export { ReactComponent as CheckboxIcon } from "assets/checkbox.svg";
export { ReactComponent as CheckedIcon } from "assets/checked.svg";
export { ReactComponent as HomeIcon } from "assets/home.svg";
export { ReactComponent as SendIcon } from "assets/send.svg";
export { ReactComponent as ExportIcon } from "assets/share.svg";

export { default as ChatWithUsIcon } from "assets/chat-with-us.png";
export { default as FilterImgIcon } from "assets/filter.png";
export { default as NextImgIcon } from "assets/next.png";
export { default as SortImgIcon } from "assets/sort.png";

export const flexLogoImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-46ee0881-fe4f-49a8-a40e-0eeea0a0bb18";
export const mySettingImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-ba9a642f-470f-45f2-9cec-698b519f6d23";
export const beforeBuyImageUri =
  "https://d5j80r6ig58b5.cloudfront.net/img/87/s00087-88379941-7f4b-4163-9bf6-525b2caaaaec";

export const topBannerImageUri =
  "https://dak6ovdfbyw15.cloudfront.net/img/722/s00722-f2e31881-2e52-4db4-8bec-3eaf02c3b8d3";

export const shopId = process.env.REACT_APP_SHOP_ID;
// export const shop = window.SHOP || {};
export const apiHost = process.env.REACT_APP_API_HOST || window.location.origin;
export const baseUrl = process.env.REACT_APP_BASEURL || "";
export const baseRoute = process.env.REACT_APP_BASE_ROUTE || "";
export const liffId = process.env.REACT_APP_LIFF_ID;
export const lineShoppingUrl = process.env.REACT_APP_LINESHOPPING_URL || "";
export const lineOAUrl = process.env.REACT_APP_LINE_AT_URL || "";
export const gaTrackingId = process.env.REACT_APP_TRACKING_ID || "";
export const imagTrackingId = process.env.REACT_APP_IMAG_TRACKING_ID || "";
export const gaCategory = process.env.REACT_APP_GA_CATEGORY || "";
export const lineChatWithUsUrlEn =
  process.env.REACT_APP_LINE_CHAT_WITH_US_URL_EN || "";
export const lineChatWithUsUrlTh =
  process.env.REACT_APP_LINE_CHAT_WITH_US_URL_TH || "";

export const getAssistanceUrl = process.env.REACT_APP_GET_ASSISTANCE_URL || "";
export const bookAnAppointmentUrl =
  process.env.REACT_APP_BOOK_AN_APPOINTMENT_URL || "";

export const stage = process.env.REACT_APP_ENV || "";
export const lineTagId = process.env.REACT_APP_LINE_TAG_ID || "";

console.log(stage);
export const Annotation = {
  Type: {
    INPUT: "INPUT",
    ITEM_LIST: "ITEM_LIST",
    CHECKBOX: "CHECKBOX",
    DATE: "DATE",
    OPTIONS: "OPTIONS",
    ORDERER: "ORDERER",
    BRANCH: "BRANCH",
    STORE_SEVEN: "STORE_SEVEN",
    STORE_FAMILY: "STORE_FAMILY",
    COUPON: "COUPON",
    POINT: "POINT",
    UPLOAD_IMAGE: "UPLOAD_IMAGE",
    POSTAL_CODE: "POSTAL_CODE",
    PHONE: "PHONE",
  },

  SystemKey: {
    PAYMENT: "payment",
    DELIVERY: "delivery",
    COUPON: "coupon",
    POINT: "point",
    ACCOUNT: "account",
    INSTALLMENT_MONTH: "installment_month",
    BRANCH: "branch",
    ADDRESS: "address",
    STORE_FAMILY: "store_family",
    STORE_SEVEN: "store_seven",
  },
  DeliveryKey: {
    STORE: "branch",
    FAMILY: "store_family",
    SEVEN: "store_seven",
  },

  DateMode: {
    DATETIME: "DATETIME",
    TIME: "TIME",
    DATE: "DATE",
    LUNAR: "LUNAR",
  },

  RefundType: {
    STRING: "STRING",
    DATE: "DATE",
    POINT: "POINT",
    PRICE: "PRICE",
    PAYMENT: "PAYMENT",
    DELIVERY: "DELIVERY",
    PAYMENT_STATUS: "PAYMENT_STATUS",
    LOGISTIC_STATUS: "LOGISTIC_STATUS",
    LINE_POINTS: "LINE_POINTS",
    PRODUT_DETAILS: "PRODUT_DETAILS",
    IMAGE: "IMAGE",
  },

  RefundAction: {
    REJECT: "拒絕",
    UNCHECK: "退貨申請中",
    APPROVE: "同意",
  },
};

export const ANNOTATION_KEYS = {
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  PHONE_AREA_CODE: "Country Code",
  PHONE: "Phone Number",
};

export const DELIVERY_URI = {
  SEVEN: "https://eservice.7-11.com.tw/e-tracking/search.aspx",
  FAMILY: "https://ecfme.fme.com.tw/fmedcfpwebv2/index.aspx",
  HOME: "https://www.t-cat.com.tw/inquire/trace.aspx", //黑貓物流
};

export const DELIVERY_HELPER_TEXT = {
  HOME: "orderForm_delievery_helper_home",
  CUSTOM: "orderForm_delievery_helper_custom",
};

export const PAGE_KEYS = {
  APPRICIATION: "appreciation",
  MESSAGE: "message",
  INSTRUCTION: "instruction",
  PRIVACY: "privacy",
  SHIPPING: "shipping",
  RETURN: "refund_info",
  TERM_OF_SALE: "privacy",
  PDPA: "pdpa",
};

export const PRIVACY_LABELS = {
  MARKEING_CONSENTS: "marketing consents",
  TERMS_OF_SALES: "terms of sales",
  PDPA_CONSENT: "pdpa consent",
};

export const DETAUL_PAGE_LABELS = {
  appreciation: "感謝頁",
  message: "訊息客製",
  instruction: "購買前須知",
  refund_info: "退貨事項",
  shipping: "運送服務條款",
  privacy: "隱私權政策",
};

export const VARIABLES = {
  STATUS: [
    { key: "UNPAID", value: "未付款" },
    { key: "SHIPPING", value: "配送中" },
    { key: "CANCEL", value: "已取消" },
    // 以防萬一
    { key: "PACKING", value: "撿貨中" },
    { key: "ARRIVED", value: "已送達" },
    { key: "RETURN_REFUND", value: "退貨/退款" },
    { key: "CANCELED", value: "已取消" },
    { key: "UNKNOWN", value: "未定義" },
  ],
  ORDER_STATUS: [
    { key: "UNPAID", value: "未付款" },
    { key: "CANCEL", value: "已取消" },
    // 以防萬一
    { key: "COMFIRMED", value: "已確認" },
    { key: "COMPLETED", value: "已完成" },
    { key: "CANCELLED", value: "已取消" },
    { key: "APPLY_REFUND", value: "退貨申請中" },
    { key: "REFUNDING", value: "退貨處理中" },
    { key: "ERROR", value: "錯誤" },
  ],
  PAYMENT: [
    { key: "ATM", value: "ATM" },
    { key: "CASH", value: "面交付款" },
    { key: "CASH", value: "貨到付款" },
    { key: "CREDIT", value: "信用卡(一次付清)" },
    { key: "CREDIT_INSTALLMENT", value: "信用卡(分期付款)" },
    { key: "LINEPAY", value: "LINE PAY" },
    { key: "CUSTOM", value: "自訂" },
  ],
  DELIVERY: [
    { key: "PICKUP", value: "面交" },
    { key: "SEVEN", value: "7-Eleven" },
    { key: "FAMILY", value: "全家" },
    { key: "HOME", value: "宅配" },
    { key: "STORE", value: "門市自取" },
    { key: "NONE", value: "無" },
    { key: "CUSTOM", value: "自訂" },
  ],
  PAYMENT_STATUS: [
    { key: "CANCEL", value: "已取消" },
    { key: "UNPAID", value: "未付款" },
    { key: "PAID", value: "已付款" },
    { key: "REFUNDING", value: "退款中" },
    { key: "REFUNDED", value: "已退款" },
    { key: "EXPIRED", value: "已過期" },
    { key: "ERROR", value: "錯誤" },
  ],
  LOGISTIC_STATUS: [
    { key: "PACKING", value: "尚未出貨" },
    { key: "SHIPPING", value: "發貨中" },
    { key: "SHIPPED", value: "已發貨" },
    { key: "ARRIVED", value: "已送達" },
    { key: "RETURNING", value: "派車退件" },
    { key: "RETURNED", value: "已退回" },
  ],
  DELIVERY_STATUS: [
    { key: "PACKING", value: "尚未出貨" },
    { key: "SHIPPING", value: "發貨中" },
    { key: "SHIPPED", value: "已發貨" },
    { key: "ARRIVED", value: "已送達" },
    { key: "RETURNING", value: "派車退件" },
    { key: "RETURNED", value: "已退回" },
  ],
};

export const IMG_MAX_SIZE = 2; // MB
export const BANNER_NAVIGATION_COLLECTION_TAG = "T";

export const LANG = {
  EN: "en",
  ZH: "zh-TW",
  TH: "th",
};

export const CATEGORY = "CATEGORY";
export const COLLECTION = "COLLECTION";

export const OUT_OF_STOCK_CART_ZH = "庫存不足，請重新選擇商品數量";
export const OUT_OF_STOCK_CHECKOUT_ZH = "此商品已售罄";
